import { useState, useContext } from 'react';
import { useHistory } from 'react-router-dom';
import { AppContext } from 'commons-ui';
import useService from '../../../useService';
import { Record } from '../../../helper';
import { getFormDefaults } from '../../formConfig';

const useCreate = () => {
	const [showLoader, setShowLoader] = useState(false);
	const { showAlert } = useContext(AppContext);
	const history = useHistory();
	const { requestUpdateFeatureSegments } = useService();

	const createNewFeatureSegment = async (featureSegmentData: Record) => {
		setShowLoader(true);
		try {
			const newfeatureSegmentData: Record = { ...featureSegmentData };
			const response: boolean = await requestUpdateFeatureSegments(newfeatureSegmentData, showAlert);
			if (response) history.goBack();
		} catch (error: any) {
			showAlert(`Error: ${error.response.data.error}`, { type: 'error' });
		} finally {
			setShowLoader(false);
		}
	};

	const handleFormSubmit = (submittedData: Record) => {
		createNewFeatureSegment(submittedData);
	};

	const handleFormCancel = () => {
		history.goBack();
	};

	return {
		data: getFormDefaults(),
		showLoader,
		handleFormSubmit,
		handleFormCancel,
		setShowLoader
	};
};

export default useCreate;
